/// <amd-module name="Wit/SprintsHub/SprintsView/Components/Taskboard/ITaskboardRow" />
import { ObservableArray, ObservableValue } from "VSS/Core/Observable";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IObservableClientWorkItem } from "Wit/ClientWorkItemService/IClientWorkItem";
import { ITaskboardWorkItem } from "Wit/SprintsHub/Common/Contracts/Interfaces";
import { TaskboardGroupBy } from "Wit/SprintsHub/Common/Constants";

export interface ITaskboardRow {
    assignedTo?: IdentityRef;
    children: ObservableArray<IObservableClientWorkItem<ITaskboardWorkItem>>;
    expanded: ObservableValue<boolean>;
    parent?: IObservableClientWorkItem<ITaskboardWorkItem>;
    rowType: TaskboardGroupBy;
}
